// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tCKf","fullView":"styles_fullView__2UKU_"};